package com.appcreator.blueprint.core

val envRegex = "\\{([a-zA-Z0-9()_.~-]+)\\}".toRegex()